import http from "@seims/shared/src/services/HttpService";

var endpoint = `system/faqs`;
const headers = {};

const addFaq = async (values) => {

  const response = http.post(`${endpoint}`, values,
    { headers: headers }
  );
  return response;
};

const updateFaq = async (values) => {

  const response = http.put(`${endpoint}/${values.id}`, values,
    { headers: headers }
  );
  return response;
};

const getFaq = async () => {
  const response = await http.get(`${endpoint}`);
  return response;
};

export default {addFaq, getFaq, updateFaq}